import cn from "classnames";
import Card from "../../../components/Card";
import Icon from "../../../components/Icon";
import Modal from "../../../components/Modal";
import tWallet from "../../../i11/TokenWallet";
import TextInput from "../../../components/TextInput";
import { useUser } from "../../../context";
import { UseDisclosure } from "../../../hooks/use-disclosure";

const HederaAccount = () => {
	// const { locale } = useUser();

	// const [accountID, setAccountID] = useState("0.0.5894501");
	return <div />;
	// return (
	// 	<Card
	// 		title={tWallet[locale].hedera_acc_detail}
	// 		classTitle={cn("title-green")}
	// 	>
	// 		<div
	// 			style={{
	// 				display: "flex",
	// 				alignItems: "center",
	// 				gap: "25px",
	// 			}}
	// 		>
	// 			<p>{accountID}</p>
	// 			<HederaModal id={accountID} setID={setAccountID} />
	// 			{accountID && (
	// 				<a
	// 					href={`https://hashscan.io/testnet/account/${accountID}?app=false&ph=1&pt=1&p2=1`}
	// 					target="_blank"
	// 					rel="noreferrer"
	// 					className="button"
	// 				>
	// 					{tWallet[locale].go_to_hedera}
	// 				</a>
	// 			)}
	// 		</div>
	// 	</Card>
	// );
};

const HederaModal = ({ id, setID }) => {
	const { locale } = useUser();
	const { isOpen, onClose, onOpen } = UseDisclosure();

	const submitHandler = () => {};
	return (
		<>
			<button className="button-stroke" onClick={() => onOpen()}>
				<Icon name="edit" />
			</button>
			{isOpen && (
				<Modal visible={isOpen} onClose={onClose}>
					<Card
						title={tWallet[locale].hedera_acc_detail}
						classTitle="title-green"
					>
						<form
							onSubmit={submitHandler}
							style={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
							}}
						>
							<TextInput
								placeHolder={"0.0.00000"}
								required
								value={id}
								// onChangeInput={(val) => setID(val)}
								// label={"Hedera Detail "}
							/>
							<button
								className={cn("button-small", {
									disabled: false,
								})}
							>
								save
							</button>
						</form>
					</Card>
				</Modal>
			)}
		</>
	);
};

export default HederaAccount;
